import {Typography} from 'components/Typography';
import {FC, useCallback} from 'react';
import style from './style.module.scss';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {showModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import Picture from 'components/Picture';
import {Box} from 'components/Grid';

const IMAGES = {
    xl: '/images/events-x-page/cert-banner-xl.webp',
    lg: '/images/events-x-page/cert-banner-lg.webp',
    sm: '/images/events-x-page/cert-banner-sm.webp',
};

export const BannerCertificateLarge: FC = () => {
    const dispatch = useAppDispatch();
    const onButtonClick = useCallback(() => {
        dispatch(showModal(MODALS.TASTING_CERTIFICATE_INFO.name));
    }, [dispatch]);

    return (
        <Box>
            <div className={style.main} onClick={onButtonClick}>
                <div className={style.content}>
                    <Typography variant={'headline-32-reg-ch'} className={style.text}>
                        Подарочный сертификат <br /> на мероприятие с&nbsp;дегустацией
                    </Typography>
                    <button className={style.button} type={'button'}>
                        <Typography variant={'button-14-m-cl'}>Подробнее</Typography>
                    </button>
                </div>
                <Picture className={style.banerPicture} sources={IMAGES} src={IMAGES.xl} />
            </div>
        </Box>
    );
};
